module.exports = __webpack_public_path__ + "static/img/1_3_2.67791d57.jpg";